import { DateTime } from 'luxon';

export const convertDateFormat = (date, fromFormat, toFormat) => {
  return date && DateTime.fromFormat(date, fromFormat).toFormat(toFormat);
};

export const parseISODateToLocaleString = (
  isoDateString,
  format = DateTime.DATETIME_MED,
) => {
  const luxonDateObj = DateTime.fromISO(isoDateString, { zone: 'utc' });
  if (luxonDateObj.isValid)
    return luxonDateObj.setZone('local').toLocaleString(format);

  return isoDateString;
};
